"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const PlaceholderLoading_1 = tslib_1.__importDefault(require("src/components/loadings/PlaceholderLoading"));
const UnderlineErrorTest_1 = tslib_1.__importDefault(require("../errors/UnderlineErrorTest"));
const TextareaField = (props) => {
    const error = props.error ? ' is-invalid' : '';
    if (props.isFetching) {
        return (0, jsx_runtime_1.jsx)(PlaceholderLoading_1.default
        //row quantity * distance between rows + initial textarea height
        , { 
            //row quantity * distance between rows + initial textarea height
            height: (props.rows || 3) * 19.5 + 18.89, containerClassName: 'd-block', containerStyle: { borderRadius: '0.42rem' } });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("textarea", { id: props.id || props.name, name: props.name, disabled: props.disabled, onChange: e => props.handleChange(e), value: props.value || '', autoComplete: props.autocomplete || 'off', className: (props.className || `form-control${props.small ? ' form-control-sm' : ''}`) + error, placeholder: props.placeholder, rows: props.rows || 3 }), (0, jsx_runtime_1.jsx)(UnderlineErrorTest_1.default, { errorMessage: props.error, style: { bottom: undefined, top: props.errorMessageTop || 24 }, tooltipErrorDirection: props.tooltipErrorDirection })] }));
};
exports.default = TextareaField;
